import LineItemsModel from '../../services/line-items';
import OrderModel from '../../services/order-model';

const SpreeAPIOrderAdapter = {
    processList: (orderListAMS) => {
        orderListAMS.data.forEach((order) => {
            SpreeAPIOrderAdapter._process(order, orderListAMS);
        });

        return orderListAMS;
    },

    processItem: (orderListAMS) => {
        SpreeAPIOrderAdapter._process(orderListAMS.data, orderListAMS);

        return orderListAMS;
    },

    /*
       PRIVATE METHODS
    */
    _process: (order, orderListAMS) => {
        if (order.relationships.billing_address.data && order.relationships.billing_address.data.id) {
            order.bill_address = SpreeAPIOrderAdapter._buildAddress(order.relationships.billing_address.data.id, orderListAMS);
        }

        if (order.relationships.shipping_address.data && order.relationships.shipping_address.data.id) {
            order.ship_address = SpreeAPIOrderAdapter._buildAddress(order.relationships.shipping_address.data.id, orderListAMS);
        }

        if (order.relationships.user.data && order.relationships.user.data.id) {
            order.user = SpreeAPIOrderAdapter._buildUser(order.relationships.user.data.id, orderListAMS);
        }

        if (order.relationships.line_items.data) {
            order.line_items = SpreeAPIOrderAdapter._buildLineItems(order.relationships.line_items.data.map((a) => a.id), orderListAMS);
        }

        if (order.relationships.shipments.data) {
            order.shipments = SpreeAPIOrderAdapter._buildShipments(order.relationships.shipments.data.map((a) => a.id), orderListAMS);
        }
    },

    _getItem: (itemId, itemCollection) => itemCollection.find((item) => item.id === itemId),

    _buildAddress: (addressId, orderListAMS) => orderListAMS.included.find((item) => item.type === 'address' && item.id === addressId),

    _buildLineItems: (lineItemIds, orderListAMS) => {
        const items = [];
        const lineItems = LineItemsModel.lineItems(lineItemIds, orderListAMS.included);

        lineItems.forEach((item) => {
            item.variant = LineItemsModel.variant(item.relationships.variant.data.id, orderListAMS.included);
            item.variant.images = LineItemsModel.images(item.variant.relationships.images.data.map((a) => a.id), orderListAMS.included);
            item.data_extras = LineItemsModel.data_extras(item.relationships.data_extras.data.map((a) => a.id), orderListAMS.included);
            item.data_extra_types = LineItemsModel.data_extra_types(item.data_extras.map((a) => a.attributes.type_id), orderListAMS.included);

            if (item.variant.images.length === 0) {
                const product = LineItemsModel.product(item.variant.relationships.product.data.id, orderListAMS.included);
                item.variant.images = LineItemsModel.images(product.relationships.images.data.map((a) => a.id), orderListAMS.included);
            }

            items.push(item);
        });

        return items;
    },

    _buildShipments: (shipmentIds, orderListAMS) => {
        const shipments = [];
        shipmentIds.forEach((shipmentId) => {
            const thisShipment = SpreeAPIOrderAdapter._getItem(shipmentId, orderListAMS.included);
            thisShipment.shipping_rates = OrderModel.shippingRates(thisShipment.relationships.shipping_rates.data.map((a) => a.id), orderListAMS.included);

            const selected = OrderModel.selectedShippingRate(thisShipment.relationships.shipping_rates.data.map((a) => a.id), orderListAMS.included);

            if (selected) {
                // eslint-disable-next-line prefer-destructuring
                thisShipment.selected_shipping_rate = selected[0];
            }

            shipments.push(thisShipment);
        });

        return shipments;
    },

    _buildUser: (userId, orderListAMS) => orderListAMS.included.find((item) => item.type === 'user' && item.id === userId),
};

export default SpreeAPIOrderAdapter;



/** WEBPACK FOOTER **
 ** ./src/apis/ams-adapters/spree-api-order-adapter.js
 **/